import styled from '@emotion/styled';
import { FreeBetIcon } from 'src/domains/layouts/shared/assets/icons/FreeBetIcon';
import { HelpIcon } from 'src/domains/layouts/shared/assets/icons/HelpIcon';
import { ChevronIcon } from 'src/domains/layouts/shared/assets/icons/ChevronIcon';
import { withConfig } from 'src/withConfig';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { css, SerializedStyles } from '@emotion/react';

export const FreeBetIconWrapper = styled(FreeBetIcon, { label: 'FreeBetIconWrapper' })`
    width: 14px;
    fill: currentcolor;
    margin: 0 5px 0 0;
`;

export const HelpIconWrapper = styled(HelpIcon, { label: 'HelpIconWrapper' })`
    width: 15px;
    fill: currentcolor;
    vertical-align: top;
    margin: 0 0 0 3px;
    cursor: pointer;
`;

interface IndicatorStatusType {
    winingBet: boolean;
    hasStatus: boolean;
    variant: DefaultComponentVariantType | null;
}

const setBetElementList = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css``;
    }
    return css`
        &::after {
            background: ${theme.star.betslipSummary.bgColor};
            content: '';
            height: 1px;
            left: 0;
            margin-top: 4px;
            position: absolute;
            right: 0;
            top: 100%;
        }
    `;
};

export const BetElementList = withConfig(theme => styled('li', { label: 'BetElementList' })<IndicatorStatusType>`
    border-color: ${({ winingBet, hasStatus }): string => hasStatus ? winingBet === true ? theme.star.betslipSummary.borderColor : theme.star.betslipSummary.borderColorSecondary : 'transparent' };
    border-style: solid;
    border-width: ${({ winingBet, hasStatus }): string => hasStatus ? winingBet === true ? '0 0 0 4px' : '0 0 0 4px' : '0'};
    color: ${theme.star.betslipGeneral.txtColor};
    margin: 10px 0;
    padding: ${({ hasStatus }): string => hasStatus === true ? '8px 0 8px 8px' : '8px 0'};
    position: relative;
    ${({ variant }): SerializedStyles => setBetElementList(variant, theme)}
    &:last-of-type {
        &::after {
            content: none;
        }
    }
`);

export const BetSelectionHeader = withConfig(theme => styled('div', { label: 'BetSelectionHeader' })`
    color: ${theme.star.betslipGeneral.txtColor};
    font-size: ${theme.star.fontSize.xRegular};
    font-weight: ${theme.star.fontWeight.bold};
    margin: 0;
    opacity: 1;
    padding-right: 10px;
    position: relative;
    text-transform: capitalize;
`);

export const BetType = styled('div', { label: 'BetType' })`
    margin-left: 16px;
`;

export const BetSelectionHeaderEventName = withConfig(theme => styled('span', { label: 'BetSelectionHeaderEventName' })`
    display: block;
    font-size: ${theme.star.fontSize.xSmall};
    font-weight: ${theme.star.fontWeight.regular};
    line-height: 1;
    margin: 0 0 8px 0;
    opacity: 0.6;
    padding-left: 16px;
`);

export const PotentialReturns = withConfig(theme => styled('span', { label: 'PotentialReturns' })`
    color: ${theme.star.betslipGeneral.txtColorTertiary};
    font-size: ${theme.star.fontSize.xRegular};
    font-weight: ${theme.star.fontWeight.bold};
`);

export const ReturnsSpan = withConfig(theme => styled('span', { label: 'ReturnsSpan' })`
    color: ${theme.star.betslipGeneral.txtColor};
    font-size: ${theme.star.fontSize.xRegular};
    font-weight: ${theme.star.fontWeight.bold};
`);

export const ArrowBetSelectionWrapper = styled(ChevronIcon, { label: 'ArrowBetSelectionWrapper' })`
    fill: currentcolor;
    left: 0;
    position: absolute;
    top: 6px;
    width: 12px;
`;
